// src/app/redux/reducers/parcoursReducer.js

import {
    FETCH_PARCOURS_REQUEST,
    FETCH_PARCOURS_SUCCESS,
    FETCH_PARCOURS_FAIL,
    GET_PARCOURS_BY_ID_REQUEST,
    GET_PARCOURS_BY_ID_SUCCESS,
    GET_PARCOURS_BY_ID_FAIL,
    CREATE_PARCOURS_REQUEST,
    CREATE_PARCOURS_SUCCESS,
    CREATE_PARCOURS_FAIL,
    UPDATE_PARCOURS_REQUEST,
    UPDATE_PARCOURS_SUCCESS,
    UPDATE_PARCOURS_FAIL,
    DELETE_PARCOURS_REQUEST,
    DELETE_PARCOURS_SUCCESS,
    DELETE_PARCOURS_FAIL,
} from '../actions/parcoursActions';

const initialState = {
    list: [],
    selectedParcours: null,
    loading: false,
    error: null,
};

const parcoursReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_PARCOURS_REQUEST:
        case GET_PARCOURS_BY_ID_REQUEST:
        case CREATE_PARCOURS_REQUEST:
        case UPDATE_PARCOURS_REQUEST:
        case DELETE_PARCOURS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case FETCH_PARCOURS_SUCCESS:
            return {
                ...state,
                list: action.payload,
                loading: false,
            };

        case GET_PARCOURS_BY_ID_SUCCESS:
            return {
                ...state,
                selectedParcours: action.payload,
                loading: false,
            };

        case CREATE_PARCOURS_SUCCESS:
            return {
                ...state,
                list: [...state.list, action.payload],
                loading: false,
            };

        case UPDATE_PARCOURS_SUCCESS:
            return {
                ...state,
                list: state.list.map((item) =>
                    item.id === action.payload.id ? action.payload : item
                ),
                selectedParcours: action.payload,
                loading: false,
            };

        case DELETE_PARCOURS_SUCCESS:
            return {
                ...state,
                list: state.list.filter((item) => item.id !== action.payload),
                loading: false,
            };

        case FETCH_PARCOURS_FAIL:
        case GET_PARCOURS_BY_ID_FAIL:
        case CREATE_PARCOURS_FAIL:
        case UPDATE_PARCOURS_FAIL:
        case DELETE_PARCOURS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        default:
            return state;
    }
};

export default parcoursReducer;
